module.exports = __webpack_public_path__ + "img/frame_djlx_titlebg.77fa8076.png";